"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrillModalFooter = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var DrillModalExportOptions_1 = tslib_1.__importDefault(require("./DrillModalExportOptions"));
var bubbleAlignPoints = [{ align: "tc bc" }];
exports.DrillModalFooter = function (_a) {
    var exportAvailable = _a.exportAvailable, exportXLSXEnabled = _a.exportXLSXEnabled, onExportXLSX = _a.onExportXLSX, exportCSVEnabled = _a.exportCSVEnabled, onExportCSV = _a.onExportCSV, isLoading = _a.isLoading;
    var _b = tslib_1.__read(react_1.useState(false), 2), showDropdown = _b[0], setShowDropdown = _b[1];
    var toggleShowDropdown = react_1.useCallback(function () { return setShowDropdown(function (oldValue) { return !oldValue; }); }, []);
    var handleOnExportXLSX = react_1.useCallback(function () {
        onExportXLSX();
        setShowDropdown(false);
    }, [onExportXLSX]);
    var handleOnExportCSV = react_1.useCallback(function () {
        onExportCSV();
        setShowDropdown(false);
    }, [onExportCSV]);
    var exportDisabled = !exportAvailable || (!exportXLSXEnabled && !exportCSVEnabled);
    var toggleButton = react_1.useMemo(function () { return (react_1.default.createElement("button", { onClick: toggleShowDropdown, className: classnames_1.default("gd-button-link-dimmed gd-button gd-icon-download export-menu-toggle-button", {
            disabled: exportDisabled,
        }), type: "button" },
        react_1.default.createElement("span", { className: "gd-button-text" },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "dialogs.export.submit" })))); }, [exportDisabled, toggleShowDropdown]);
    return (react_1.default.createElement("div", { className: classnames_1.default("s-export-drilled-insight export-drilled-insight", {
            "is-disabled": exportDisabled,
        }) }, exportDisabled && !isLoading ? (react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, null,
        toggleButton,
        react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: "bubble-primary", alignPoints: bubbleAlignPoints },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "export_unsupported.disabled" })))) : (react_1.default.createElement(react_1.default.Fragment, null,
        toggleButton,
        react_1.default.createElement(DrillModalExportOptions_1.default, { showDropdown: showDropdown, toggleShowDropdown: toggleShowDropdown, exportXLSXEnabled: exportXLSXEnabled, exportCSVEnabled: exportCSVEnabled, onExportXLSX: handleOnExportXLSX, onExportCSV: handleOnExportCSV })))));
};
//# sourceMappingURL=DrillModalFooter.js.map